import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import headacheLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet'; // Import Helmet for managing head tags
import SignupForm from './utils/SignupForm';
import HealthSection from './utils/HealthSection';

const PhysiotherapyTreatmentAndExercisesForHeadaches = () => {
    return (
        <div>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Expert Physiotherapy for Headache Management</h1>
                    <h2>Discover how physiotherapy treatment and exercises can alleviate headaches, providing relief without medication at Ramp Physio and Fitness.</h2>
                    <p>Headaches can be debilitating, but with the right physiotherapy treatment and exercises, it's possible to reduce their frequency and intensity. At Ramp Physio and Fitness, we specialize in providing targeted therapies and exercise programs designed to address the root causes of headaches. Our approach is grounded in evidence-based techniques that offer natural relief and empower you to take control of your health. In this comprehensive guide, we will delve into how our team can help you manage and prevent headaches through specialized physiotherapy.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>Understanding Headache Types</h1>
                        <p>Headaches come in various forms, each with distinct characteristics. Tension-type headaches are the most common, often related to muscle tightness in the neck and shoulders. Migraines, on the other hand, are intense and pulsating, sometimes accompanied by other symptoms like nausea and light sensitivity. Cervicogenic headaches originate from the cervical spine or neck region. Our physiotherapists are skilled in diagnosing and treating all types of headaches, tailoring our approach to your specific needs.</p>

                        <p>Identifying trigger points, assessing posture, and analyzing movement patterns are crucial steps in our evaluation process. This comprehensive assessment helps us create an effective treatment strategy aimed at not only relieving pain but also preventing future episodes.</p>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/dumbbells.webp" alt="Exercise" />
                    </div>
                </div>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Manual Therapy Techniques</h1>
                    <p>Manual therapy is a cornerstone of our treatment approach for headaches. Techniques such as soft tissue massage, joint mobilization, and dry needling can alleviate tension and improve mobility in the neck and shoulders, often providing immediate relief from headache pain.</p>

                    <p>Our trained physiotherapists use their hands to gently manipulate muscles and joints, releasing tightness and restoring function. This hands-on approach is complemented by specific exercises designed to maintain the improvements achieved during treatment sessions.</p>
                </div>
            </div>
            </SkewedContainer>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={headacheLogo} alt="Headache Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>

            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Targeted Exercise Programs</h1>
                    <p>Exercise is a powerful tool in the management of headaches. Our physiotherapists prescribe targeted exercises that can be performed at home or in the clinic to strengthen the muscles supporting the neck and upper back, reduce muscle tension, and improve posture.</p>

                    <p>These exercises are selected based on your individual needs and may include stretching, strengthening, and aerobic activities. Consistency is key, and our team provides ongoing support to ensure that you are performing exercises correctly and making progress towards headache relief.</p>
                </div>
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Pinloaded.webp" alt="Exercise" />
                    </div>
                    <div className="service-intro-content2">
                        <h1>Educational Resources and Support</h1>
                        <p>Knowledge is power when it comes to managing headaches. We equip you with educational resources that explain the causes of headaches, the role of physiotherapy in treatment, and how lifestyle factors such as stress and diet can impact your symptoms.</p>
                        <p>Our physiotherapists offer guidance on ergonomics, relaxation techniques, and other self-management strategies to help you reduce the likelihood of headache recurrence. We are committed to supporting you in making informed decisions about your health and well-being.</p>

                        <br></br>
                        <p>
                            In conclusion, physiotherapy treatment and exercises for headaches are effective, non-pharmacological ways to manage and prevent this common condition. At Ramp Physio and Fitness, our team is dedicated to providing personalized care that addresses the unique needs of each client. By combining manual therapy, targeted exercises, and educational support, we help you achieve lasting relief and improve your quality of life. Take the first step towards headache-free living by booking an appointment with us today.
                        </p>
                    </div>
                </div>
            </SkewedContainer>
            <SubpagesLink />

            <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default PhysiotherapyTreatmentAndExercisesForHeadaches;